// Shared between the browser app and Pages Functions (the embed policy needs the tenant of a page).

export interface Route {
  slug: string | null;
  page: 'app' | 'privacy';
}

/** Tenant comes from the first path segment (`/<slug>`), the `tenant` query parameter, or the deployment default. */
export function parseRoute(loc: { pathname: string; search: string }, fallback: string | null): Route {
  const parts = loc.pathname.split('/').filter(Boolean);
  const query = new URLSearchParams(loc.search).get('tenant');
  return { slug: parts[0] ?? query ?? fallback, page: parts[1] === 'privacy' ? 'privacy' : 'app' };
}

/** Paths that can never be a company slug. */
export const RESERVED_SLUGS = new Set(['admin', 'api', 'assets', 'tenants', 'embed', 'privacy', 'static', 'www']);
